export const scenesConfig = [
  {
    categoryId: '426e0070e5014e46a2f4f883600a10ff',
    productId: 'f5d0257d25884520abf034b0889424a9',
    title: '塔基',
    belongTo: {
      name: '风电',
      id: '4c5eee5ad3ca4eb5b7cef811718a547e'
    }
  },
  {
    categoryId: 'db44a3de67f24f9eb8d126271aa8e937',
    productId: '15eb4f5e0e51448c8799806e69d38e8b',
    title: '机舱',
    belongTo: {
      name: '风电',
      id: '4c5eee5ad3ca4eb5b7cef811718a547e'
    }
  },
  {
    categoryId: 'a9fcd58d66f14a7fb133a7f9dcd76c15',
    productId: 'db47f41e93f34639928d3fb74ce0ed63',
    title: '集中式光伏电站',
    belongTo: {
      name: '光伏',
      id: '9dc96b6616a6412eb87178cb4a67d71e'
    }
  },
  {
    categoryId: '69c8512cfe594c5f8d88ef126222d4be',
    productId: 'de2888d3a3ef4ca999d6a4de0f399061',
    title: '分布式光伏电站',
    belongTo: {
      name: '光伏',
      id: '9dc96b6616a6412eb87178cb4a67d71e'
    }
  },
  {
    categoryId: 'adf9a8ab65e24c79966a1dbacad95eb9',
    productId: '81b476f0b0d54a62968b1dee40430130',
    title: '屋顶光伏系统',
    belongTo: {
      name: '光伏',
      id: '9dc96b6616a6412eb87178cb4a67d71e'
    }
  },
  {
    categoryId: '42d485860659417383ff9dc3c34d2122',
    productId: '1774bd13a1b84a369d1ec76c1d5487a3',
    title: '石化',
  },
  {
    categoryId: '07003f63c76944cb986d4eaee4b2802b',
    productId: '58581cab7a524136b03f284647a8a666',
    title: '下游',
    belongTo: {
      name: '石化',
      id: '1774bd13a1b84a369d1ec76c1d5487a3',
      type: 'mid_3d'
    }
  }
];

export const hotspotConfig = {

  //场景首页
  '2d_gdjt': { // 轨道交通
    type: 'detail',
    id: 'c7a68487-7077-4e3d-bafe-257657137d86',
    tag: 'home'
  },
  '2d_gk': { // 港口
    type: 'detail',
    id: '75e509ed-5127-41c8-b52d-94acf57f3b53',
    tag: 'home'
  },
  '2d_mh': { // 民航
    type: 'detail',
    id: 'f6f9020d-ae58-4417-b562-d0ebe7804be5',
    tag: 'home'
  },
  '2d_dx': { // 电信
    type: 'detail',
    id: '8b3cb901-9c5b-49eb-bb96-2eaa87cbcc4b',
    tag: 'home'
  },
  '2d_jz': { // 建筑
    type: 'detail',
    id: 'a32154d8-66aa-4793-a280-a6e6e9ce8b82',
    tag: 'home'
  },
  '2d_cn': { // 储能
    type: 'detail',
    id: 'cc06fa45-cfed-458d-bba0-463160e93df9',
    tag: 'home'
  },
  '2d_led': { // LED 路灯
    type: 'detail',
    id: '13851da0-df69-4ac0-b3a7-7c2df19c385a',
    tag: 'home'
  },
  '2d_ddqc': { // 电动汽车
    type: 'detail',
    id: '3acae55c-f236-4a2f-9f55-f9a59e169dc0',
    tag: 'home'
  },
  '2d_zndw': { // 智能电网
    type: 'detail',
    id: 'ec77c5fa-d6f2-47be-af2c-fb2ffde9c72c',
    tag: 'home'
  },
  '2d_dl': { // 电力
    type: 'detail',
    id: 'f721233c-2c23-4151-9559-eaae5b4f2d8b',
    tag: 'home'
  },

  '3d_gf': { // 光伏
    type: 'mid_2d',
    id: '9dc96b6616a6412eb87178cb4a67d71e',
    tag: 'home'
  },

  '3d_fd': { // 风电
    type: 'mid_2d',
    id: '4c5eee5ad3ca4eb5b7cef811718a547e',
    tag: 'home'
  },

  '3d_sh': { // 石化
    type: 'mid_3d',
    id: '1774bd13a1b84a369d1ec76c1d5487a3',
    tag: 'home'
  },

  //石化总场景
  'zy': {
    type: 'mid_2d',
    id: 'c68828fbe82e4b26b52d8ba1068feccb'
  },
  'xy': {
    type: 'mid_3d',
    id: '58581cab7a524136b03f284647a8a666'
  },

  // 石化 - 石化下游
  'xy_zks': { // 总控室
    type: 'detail',
    id: '90f3f643-639f-4469-b5e1-40023760701d'
  },
  'xy_kyz': { // 空压站
    type: 'detail',
    id: 'c977ca6f-bacb-492c-95f9-5fc684fe86f3'
  },
  'xy_yqgd': { // 油气管道
    type: 'detail',
    id: '2785e406-80c4-4051-bccb-35209e2a4c96'
  },
  'xy_cyg': { // 储油罐
    type: 'detail',
    id: '080f878a-ff31-4f87-af61-56e167d6f857'
  },
  'xy_zlt': { // 蒸馏塔
    type: 'detail',
    id: 'e8662597-a6ac-4855-b960-84f635fa2e17'
  },
  'xy_kzs': { // 控制室
    type: 'detail',
    id: '622b1e92-afe8-41bb-95b4-7f8bcd072682'
  },
  'xy_spjk': { // 视频监控
    type: 'detail',
    id: 'eaaeddf0-dea4-4220-8db3-ab31a6432562'
  },
  'xy_jdxt': { // 接地系统
    type: 'detail',
    id: '9a188bdb-b571-4daf-a40f-5f100523b1dd'
  },

  // 风电 - 风机机舱
  'fl_bjxt': { // 变桨系统
    type: 'detail',
    id: 'bb98b28b-3a62-4482-8ecf-ac0f95c0c74f'
  },
  'fl_jckzg': { // 机舱控制柜
    type: 'detail',
    id: '6ddece30-a08e-4215-b02a-84e2d1d01d42'
  },
  'fl_fdj': { // 发电机
    type: 'detail',
    id: 'c96c5b17-fdcd-4ba4-8b68-85d6f8be20ee'
  },
  'fl_ldjc': { // 雷电监测系统
    type: 'detail',
    id: 'edae11e2-0951-4635-b008-1d6af80fd8c5'
  },
  'fl_jsxt': { // 接闪系统
    type: 'detail',
    id: '71117f4d-a446-4eba-acb7-85b2ffff14b6'
  },
  'fl_ypcb': { // 叶片除冰系统
    type: 'detail',
    id: 'f0decfac-1916-4947-9951-f17ec17de3b8'
  },
  // 风电 - 塔基
  'fl_blxt': { // 变流系统
    type: 'detail',
    id: 'd83c495d-144a-4dc0-a7f5-6159aebeb618'
  },
  'fl_tjkzg': { // 塔基控制柜
    type: 'detail',
    id: '9f01a2dc-ce7d-4c84-b038-71b4411d7f17'
  },
  'fl_byq': { // 变压器
    type: 'detail',
    id: '6c297021-8c26-43f9-9c44-ae80234e07c4'
  },
  'fl_jdxt': { // 接地系统
    type: 'detail',
    id: 'c45cbe00-17a4-458d-9b4b-d0d57520e589'
  },

  // 光伏 - 集中式光伏电站
  'jz_jzsjbq': { // 集中式逆变器
    type: 'detail',
    id: '57ebc339-b85f-42dc-b019-c0fdadcb789d'
  },
  'jz_hlx': { // 汇流箱
    type: 'detail',
    id: '3b69aa04-4663-46b0-b8dc-1e8f506eb0cb'
  },
  'jz_ddwlj': { // 等电位连接
    type: 'detail',
    id: '2d051605-1d9f-48c0-b924-c79d37897406'
  },
  'jz_jsq': { // 接闪器
    type: 'detail',
    id: '37361749-090d-4ccd-b4ea-e631ce7df5f2'
  },

  // 光伏 - 分布式光伏电站
  'fb_zcsnbq': { // 组串式逆变器
    type: 'detail',
    id: 'c5a250c1-8d78-45c9-b23b-377b1ac54e8f'
  },
  'fb_jlpdg': { // 交流配电柜
    type: 'detail',
    id: '9ff1bde8-9f6c-469e-a8ec-bf7da95adead'
  },
  'fb_ddwlj': { // 等电位连接
    type: 'detail',
    id: 'd07076f5-4112-4912-9097-ed84cff61924'
  },
  'fb_jsq': { // 接闪器
    type: 'detail',
    id: '52b48cd4-0be8-4360-b11e-33f21a8dd31b'
  },

  // 光伏 - 屋顶式光伏
  'wd_zpdg': { // 主配电柜
    type: 'detail',
    id: '8e443008-cfec-4557-878c-74811abdb121'
  },
  'wd_zcsnbq': { // 组串式逆变器
    type: 'detail',
    id: 'b12a2e50-c708-43d1-97cd-9fdc1e1cdcba'
  },
  'wd_ddwlj': { // 等电位连接
    type: 'detail',
    id: 'c48f8289-f286-46c1-bcc0-f9218b579c20'
  },
  'wd_jsxt': { // 接闪系统
    type: 'detail',
    id: 'cbe75986-f686-44f6-8e19-02271115eac0'
  },
};

export const getTitle = (productId) => {
  let title = '';
  for (let i = 0; i < scenesConfig.length; ++i) {
    if (scenesConfig[i].productId === productId) {
      title = scenesConfig[i].title;
      break;
    }
  }
  return title;
};

export const belongTo = (productId) => {
  let belongTo = '';
  for (let i = 0; i < scenesConfig.length; ++i) {
    if (scenesConfig[i].productId === productId) {
      belongTo = scenesConfig[i].belongTo;
      break;
    }
  }
  return belongTo;
};

export const getProduct = (categoryId) => {
  let productId = '';
  for (let i = 0; i < scenesConfig.length; ++i) {
    if (scenesConfig[i].categoryId === categoryId) {
      productId = scenesConfig[i].productId;
      break;
    }
  }
  return productId;
};

export const getCategory = (productId) => {
  let categoryId = '';
  for (let i = 0; i < scenesConfig.length; ++i) {
    if (scenesConfig[i].productId === productId) {
      categoryId = scenesConfig[i].categoryId;
      break;
    }
  }
  return categoryId;
};